import { call, put } from 'redux-saga/effects'

import { fetchDataWorker } from '../../apiRequest/saga/worker'
import { TEXTS } from '../types'

import { textsAPI } from '@/api/textsAPI'
import { setTextsDataAction } from '@/bus/texts'

export function* getTextsWorker({ payload }: any) {
  // @ts-ignore
  const { response } = yield call(fetchDataWorker, {
    api: textsAPI.getTextsBySlug,
    type: TEXTS,
    params: { params: payload }
  })

  if (response?.status === 'success') {
    yield put(setTextsDataAction({ data: response.data, loaded: true }))
  }
}
